import axios  from "../../services/axios";
import { constants } from '../../constants';
export const fetchCoupons = async () => {
  try {
    const response = await axios.get('/coupons');
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch coupons Please try again later.';
    throw new Error(message);
  }
};

export const fetchCouponDetails = async (id) => {
  try {
    const response = await axios.get(`/coupons/${id}`);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch coupon details. Please try again later.';
    throw new Error(message);
  }
};

export const createCoupon = async (formData) => {
  try {
    const payload = new FormData();
    payload.append('code', formData.code);
    payload.append('type', formData.type);
    payload.append('value', formData.value);
    payload.append('start_date', formData.start_date);
    payload.append('end_date', formData.end_date);
    payload.append('minimum_purchase_value', formData.minimum_purchase_value);
    payload.append('status', formData.status ? '1' : '0'); // ✅ Enforce boolean as 1 or 0

    const response = await axios.post('/coupons', payload);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to create coupon. Please try again.';
    throw new Error(message);
  }
};
export const updateCoupon = async ({ id, ...formData }) => {

  try {
    const payload = new FormData();
    payload.append('code', formData.code);
    payload.append('type', formData.type);
    payload.append('value', formData.value);
    payload.append('start_date', formData.start_date);
    payload.append('end_date', formData.end_date);
    payload.append('minimum_purchase_value', formData.minimum_purchase_value);
    payload.append('status', formData.status === constants.COUPEN_STATUS.ACTIVE ? '1' : '0');

    // Laravel expects PUT method → Add _method override
    payload.append('_method', 'PUT');

    const response = await axios.post(`/coupons/${id}`, payload); // ✅ Await here
    return response.data;

  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to update coupon. Please try again.';
    throw new Error(message);
  }
};

export const deleteCoupon = async (id) => {
  try {
    const response = await axios.delete(`/coupons/${id}`);
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to delete coupon. Please try again.';
    throw new Error(message);
  }
};
